import { DetailComponent } from './detail/detail.component';
import { RequestComponent } from './request/request.component';
import { HomeComponent } from './home/home.component';
import { ResultComponent } from './result/result.component';

// todo: poner guard a personal y third
export const NewChildRoutes = [
  {
    path: 'personal',
    component: RequestComponent,
  },
  {
    path: 'third',
    component: RequestComponent,
  },
  {
    path: 'success/:ofuscatedData',
    component: ResultComponent,
  },
  {
    path: 'failure/:ofuscatedData',
    component: ResultComponent,
  },
  {
    path: 'detail/:ofuscatedData',
    component: DetailComponent,
  },
  {
    path: '', // child route path
    component: HomeComponent, // child route component that the router renders
  },
];
